import React from "react";
import Loader from "react-loader-spinner";
import { useSelector } from "react-redux";

const PageSpinner = props => {
	const { settings } = useSelector(state => state.settings);

	return props.spinners && props.spinners.length ? (
		<div className="page-spinner-wrapper">
			{props.spinners.map(spinner => (
				<div key={spinner} className="center page-loader">
					<Loader
						type="ThreeDots"
						color={
							settings && settings.mainColor ? settings.mainColor : "#32064A"
						}
						height={80}
						width={80}
					/>
				</div>
			))}
		</div>
	) : null;
};

export default PageSpinner;
